export const getList = (list) => {
    return {
        type: 'LIST_OF_EVENTS_FETCHED',
        payload: list
    }
}


// WEBPACK FOOTER //
// ./src/containers/Events/eventsAcitons.js